export default __webpack_public_path__ + "static/img_bubbles_community_dark-673a81e1751a9f8ac6445b52548fda97.svg";